// extracted by mini-css-extract-plugin
export default {"container":"Course_container__rInKS","programContainer":"Course_programContainer__2T11P","contentContainer":"Course_contentContainer__lbHjz"};